import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { IonButton } from '@ionic/react'
import { uniqueId } from 'lodash'

import { TippingModal } from '../TippingModal'

type SendTipButtonProps = {
  className?: string
  userId: UUID
  initialAmount?: number
}

export const SendTipButton: FC<SendTipButtonProps> = ({
  className = '',
  userId,
  initialAmount,
}) => {
  const { t } = useTranslation('common')
  const uuid = useMemo(() => uniqueId(), [])

  return (
    <>
      <IonButton
        id={`send-tip-button-${uuid}`}
        className={`m-0 normal-case tracking-normal ${className}`}
        size="small"
        fill="outline"
        color="primary"
      >
        {t('tip.actions.sendTip')}
      </IonButton>
      <TippingModal userId={userId} initialAmount={initialAmount} uuid={uuid} />
    </>
  )
}
